import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { Row, Col, Form, Input, Select, Upload, Divider, Space, Button as AntdButton, DatePicker, message, Spin, Drawer, Modal } from 'antd';
import moment from 'moment';
import "moment-timezone";
import ImgCrop from 'antd-img-crop';
import { Scrollbars } from 'react-custom-scrollbars';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { PlusCircleOutlined, CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Link, useHistory } from "react-router-dom";
import FeatherIcon from 'feather-icons-react';
import InitialData from './InitialData.json'
import DetailsPage from './DetailsPage/Detailspage';
import ContactFields from './DetailsPage/ContactDeatilsFiled'
import RelatedTab from './DetailsPage/RelatedTab'
import AddTaskPage from './AddTask'
import AddDealPage from './AddDeals'
import ContactRightData from './DetailsPage/ContactRightData'
import { UploadUserTag } from './GlobalComponents/UserCardCmnts'
import { RelatedDocUpload } from './GlobalComponents/RelatedDocUpload'
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { getStateData, getCityData, getCountryData, getAllUsersData, getLeadsourceData } from '../../../Api/Services/CommonApiService';
import { FetchContactDetails, createContacts, updateContacts, } from '../../../Api/Services/ContactApiService';
import { FetchAllAccount } from '../../../Api/Services/AccountApiService';
import { Main, BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { useExcryptedNavigation, useNavigationDecrypted } from '../Filters/FilterConditions';
import Heading from '../../../components/heading/heading';
import { getBaseURL } from '../../../Api/ApiConfig'
import Popup from '../Popup/COMassPopup'
import NotesPopup from '../Popup/NotesPopup'
import CallLogPopup from '../Popup/CallLogPopup'
import AddAccountPopup from '../Popup/AccountPopup'
import AllCancelPopup from '../Popup/AllCancelPopup';
import UpdateConnectionPopup from '../Popup/UpdateConnectionPopup';
import DefaultMessagePopup from '../Popup/DefaultMessagePopup'
import Approvaldialog from '../Popup/Approvaldialog'
import ComposeMail from '../Email/Compose';
import MeetingLiPopup from '../Popup/MeetingLiPopup'
import MergePage from '../Popup/MergePage'
import SharePopup from '../Popup/SharePopup'
import AddtoCampaignPopup from '../Popup/AddtoCampaignPopup'
import { CalendarIcon, CallLogIcon, CampaignIcon, CancelIcon, ChangeOwnerIcon, CloneIcon, DealIcon, DeleteIcon, EditIcon, EmailIcon, MergeIcon, NotesIcon, SaveIcon, ShareIcon, TaskIcon } from '../../../components/Icons/Icons';
import { mobileOnChangeValidator, nameOnChangeValidator, validateZipCode, validateUrlField, validateEmailField, validateDescriptionField, validateAddressLine } from '../../../components/utilities/utilities'; // validateUrlField

const { Option } = Select;

function AddNew({ UrlId, FromPage, setCratePage, GetAll, ShortCut }) {
    const prevValues = useRef({ UrlId: "", FromPage: "" });
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const { emailapiValues, emailactiontype } = useSelector((state) => state.EmailData);
    const localData = useSelector((state) => state.localRedux);
    const companyProfile = localData.company
    const permission = localData.permissions
    const ProfileData = localData.profile
    const profile = ProfileData
    const dispatch = useDispatch();
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    const history = useHistory();
    const [form] = Form.useForm();
    function extractTimeZoneName(tzString) {
        const parts = tzString.split(" ");
        return parts[1];
    }
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    const currentDate = new Date(currentrealTime);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    const hours = String(currentDate.getHours()).padStart(2, '0');
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    const formattedTime = `${hours}:${minutes}`;
    const [contactIDs, setContactIDs] = useState()
    const [updatePopup, setUpdatePopup] = useState(false)
    const [popupType, setPopupType] = useState()
    const [contactInitial, setContactInitial] = useState()
    const [createPageTask, setCreatePageTask] = useState()
    const [contactsource, setContactSource] = useState([])
    const [edit, setEdit] = useState(false)
    const [uiReady, setUiReady] = useState(false)
    const [trigger, setTrigger] = useState()
    const [mergeOpen, setMergeOpen] = useState(false)
    const [contactId, setContactId] = useState()
    const [displayData, setDisplayData] = useState()
    const [users, setUsers] = useState([])
    const [country, setCountry] = useState()
    const [dataPermissions, setDataPermissions] = useState()
    const [allCountry, setAllCountry] = useState([])
    const [deleteOption, setDeleteOpen] = useState(false);
    const [state, setState] = useState()
    const [allState, setAllState] = useState([])
    const [city, setCity] = useState()
    const [allCity, setAllCity] = useState([])
    const [drawerPage, setDrawerPage] = useState()
    const [createPages, setCratePages] = useState()
    const [editField, setEditField] = useState(false)
    const [checked, setChecked] = useState(false)
    const [image, setImage] = useState()
    const [account, setAccount] = useState([])
    const [addAccount, setAddAccount] = useState(false)
    const [FILEList, setFileList] = useState([]);
    const [errorData, setErrorData] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [assignOwner, setAssignOwner] = useState()
    const [action, setAction] = useState()
    const [notePopup, setNotePopup] = useState(false)
    const [callLogPopup, setCallLogPopup] = useState(false)
    const [NacTrigger, setNaCTrigger] = useState()
    const [approveOpen, setApproveOpen] = useState(false)
    const [campaignPopup, setCampaignPopup] = useState(false)
    const [page, setPage] = useState()
    const [mailOpen, setMailOpen] = useState(false)
    const [meetingAttendees, setMeetingAttendees] = useState([])
    const [permissions] = useState(permission.entity)
    const [taskProp, setTaskProp] = useState()
    const [taskPage] = useState("AddPage")
    const [pages] = useState("Meeting")
    const [popupMessage, setPopupMessage] = useState(false)
    const [meetingOpen, setMeetingOpen] = useState(false)
    const [approveCondition, setApproveCondition] = useState(false)
    const [dataForDeal, setDataForDeal] = useState()
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [sharePopup, setSharePopup] = useState(false)
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const [deleteClick, setDelteClick] = useState(false)
    const [expectedClosureDate, setExpectedClosureDate] = useState(null)
    const formatDateString = (dateString, format) => {
        return moment(dateString, "YYYY-MM-DD").format(format);
    };
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }
    const scroolup = () => {
        const currentPosition = window.scrollY;
        if (currentPosition > 0) {
            const scrollStep = Math.max(1, Math.ceil(currentPosition / 20));
            window.scrollTo(0, currentPosition - scrollStep);
            requestAnimationFrame(scroolup);
        }
    }
    const PageCancel = () => {
        history.push('/Home/residents')
    }
    // Create
    const canCreate = (rolePermissions, actionRoleId) => {
        if (!Array.isArray(rolePermissions)) return false;
        const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
        return hasRolePermission;
    };
    // Share
    const canShare = (dataPermissions, action) => {
        if (!dataPermissions) return false;
        const normalizedDataPermissions = dataPermissions.split(",").map((p) => p.trim().toLowerCase());
        const hasDataPermission = normalizedDataPermissions.includes(action.toLowerCase());
        return hasDataPermission;
    };
    // Update/Delete
    const hasRoleDeletePermission = (rolePermissions, actionRoleId) => {
        if (!Array.isArray(rolePermissions)) return false;
        return rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
    };
    const canUpdateDelete = (rolePermissions, dataPermissions, action, actionRoleId) => {
        if (!Array.isArray(rolePermissions) || !dataPermissions) return false;
        const normalizedDataPermissions = dataPermissions.split(",").map((p) => p.trim().toLowerCase());
        const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
        const hasDataPermission = normalizedDataPermissions.includes(action.toLowerCase());
        return hasRolePermission && hasDataPermission;
    };
    const normalizeValue = (value) => {
        if (value === undefined || value === "") return null;
        return value;
    };
    const successMessage = (titles, data, type) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    {type === "Approve" ? <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /> : <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />}
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => {
                modal.destroy();
                if (type === "Approve") {
                    // setTimeout(() => {
                    history.push('/Home/residents')
                    // getData(contactId);
                    // }, 1000);
                }
            }
        });
    }
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };

    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    const onnavigate = () => {
        history.push("/Home/email-config")
    }
    const getCity = async (Address, isoCode) => {
        try {
            const response = await getCityData(isoCode)
            setAllCity(response);
            if (Address.city) {
                setCity(Address.city)
            }
        } catch (error) {
            message.error(error)
        }
    }
    const getState = async (Address, option) => {
        try {
            const response = await getStateData(option)
            setAllState(response);
            if (Address.state) {
                setState(Address.state)
                const stateinfo = response.find(states => states.state === Address.state);
                if (stateinfo) {
                    const iso = stateinfo.stateId
                    getCity(Address, iso)
                }
            }
        } catch (error) {
            message.error(error)
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }} >
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getContactsource = async () => {
        try {
            const data = await getLeadsourceData()
            const options = data.map((option, i) => (
                <Option value={option.leadSourceId} key={i}>
                    {option.leadSourceName}
                </Option>));
            setContactSource(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function AccountApi() {
        try {
            const data = await FetchAllAccount()
            let accountInfo = data;
            if (displayData?.account_id) {
                const isAlreadyIncluded = data?.some(contact => contact.account_id === displayData?.account_id);
                if (!isAlreadyIncluded) {
                    accountInfo = [...accountInfo, { account_name: displayData?.account_name, account_id: displayData?.account_id, account_type_name: "Customer" }];
                }
            }
            setAccount(accountInfo)
        } catch (error) {
            message.error(error)
        }
    }
    const FileUpload = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: 'image/*',
        action: `${getBaseURL()}/usermgmt/uploadFile`, // api for image upload
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
                // setState({ ...state, file: info.file, list: info.fileList });
            }
            if (status === 'done') {
                setImage(info.file.response.mediaUrl);// to set that image url
                setDeleteOpen(true)
                message.success(`${info.file.name} File upload successful`);
            } else if (status === 'error') {
                message.error(`${info.file.name} File upload failed`);
            }
        },
        listType: 'picture',
        showUploadList: false,
    };
    const handleDeleteImage = () => {
        setImage(null);
        setDeleteOpen(false);
    };
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            setAllCountry(response)
            if (displayData.country) {
                const countryInfo = response.find(countrys => countrys.country === displayData.country);
                if (countryInfo) {
                    const iso = countryInfo.countryId
                    getState(displayData, iso)
                }
            }
        }
        catch (error) {
            message.error(error)
        }
    }
    const handleCountryChange = async (value, option) => {
        setCountry(value);
        if (option.key) {
            try {
                const response = await getStateData(option.key)
                setAllState(response);
                setState()
                setCity()
                setAllCity([])
            } catch (error) {
                message.error(error)
            }
        } else {
            setAllState([]);
            setAllCity([])
            setState()
            setCity()
        }
    }
    const handleStateChange = async (value, option) => {
        setState(value);
        if (option.key) {
            try {
                const response = await getCityData(option.key)
                setAllCity(response);
                setCity()
            } catch (error) {
                message.error(error)
            }
        }
        else {
            setAllCity([]);
            setCity()
        }
    }
    const handleCityChange = (value) => {
        setCity(value)
    }
    const Callback = (accountId) => {
        form.setFieldsValue({
            accountName: accountId
        });
    }
    async function setInitialData(value) {
        setContactInitial({
            seniorityLevelId: normalizeValue(value.seniority_level_id),
            firstName: normalizeValue(value.first_name),
            lastName: normalizeValue(value.last_name),
            leadOwner: normalizeValue(value.lead_owner),
            accountId: normalizeValue(value.account_id),
            title: normalizeValue(value.title),
            reportingTo: normalizeValue(value.reporting_to),
            assitantName: normalizeValue(value.assitant_name),
            department: normalizeValue(value.department),
            email: normalizeValue(value.email),
            phone: normalizeValue(value.phone),
            fax: normalizeValue(value.fax),
            designation: normalizeValue(value.designation),
            mobile: normalizeValue(value.mobile),
            contactSourceId: normalizeValue(value.contact_source_id),
            contactFiles: (value.contact_files || []),
            contactProfile: normalizeValue(value.contact_profile),
            assitantContactNumber: normalizeValue(value.assitant_contact_number),
            emailOtpOut: normalizeValue(value.email_otp_out === 1 || value.email_otp_out === true),
            description: normalizeValue(value.description),
            city: normalizeValue(value.city),
            street: normalizeValue(value.street),
            country: normalizeValue(value.country),
            postcode: normalizeValue(value.postcode),
            state: normalizeValue(value.state),
            linkedinUrl: normalizeValue(value.linkedin_url)
        })
    }
    const setData = async (value) => {
        if (value !== undefined) {
            if (drawerPage !== "CloneLead") {
                if (value.approved_for !== "None") {
                    setApproveOpen(true)
                    setApproveCondition(true)
                }
                else {
                    setApproveOpen(false)
                    setApproveCondition(false)
                }
            }
            setAssignOwner(value.lead_owner)
            form.setFieldsValue({
                assistantcontactnumber: value.assitant_contact_number,
                accountName: value.account_id,
                assistantname: value.assitant_name,
                department: value.department,
                description: value.description,
                email: value.email,
                fax: value.fax,
                contactSource: value.contact_source_id,
                firstName: value.first_name,
                lastName: value.last_name,
                leadOwner: value.lead_owner,
                mobile: value.mobile,
                phone: value.phone,
                postcode: (value.postcode === "0" || value.postcode === 0) ? null : value.postcode,
                reportingto: value.reporting_to,
                street: value.street,
                title: value.title,
                designation: (value.designation !== "" && value.designation !== null && value.designation !== "Not Applicable") ?
                    moment(formatDateString(value.designation, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
                    : null,
                seniorityLevel: value.seniority_level_id,
                country: value.country,
                linkedinUrl: value.linkedin_url,
            })
            setExpectedClosureDate((value.designation !== "" && value.designation !== null && value.designation !== "Not Applicable") ? value.designation : null)
            setFileList(value.contact_files || [])
            setImage(value.contact_profile)
            setDeleteOpen(value.contact_profile && value.contact_profile !== "")
            setChecked(value.email_otp_out === 1 || value.email_otp_out === true)
            setContactId(value.contacts_id)
            setStates({
                ...states,
                selectedRowKeys: [value.contacts_id]
            });
            setCountry(value.country)
        }
    }
    async function deleteMenu(ids) {
        setContactIDs([ids])
        setUpdatePopup(true)
        setPopupType("Delete")
    }
    async function getSharingPermissions(id) {
        if (id) {
            setDataPermissions(id)
        }
        else {
            setDataPermissions("Read,Update,Delete,Sharing")
        }
    }
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const formattedDate = converted.format(dateFormat);

        return formattedDate
    }

    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        setApproveOpen(false)
        setApproveCondition(false)
        setAssignOwner(null)
        form.setFieldsValue({
            assistantcontactnumber: null,
            accountName: null,
            assistantname: null,
            department: null,
            description: null,
            email: null,
            fax: null,
            contactSource: null,
            firstName: null,
            lastName: null,
            leadOwner: null,
            mobile: null,
            phone: null,
            postcode: null,
            reportingto: null,
            street: null,
            title: null,
            country: null,
            designation: null,
            seniorityLevel: null,
            linkedinUrl: null,
        })
        setExpectedClosureDate(null)
        setFileList([])
        setImage()
        setDeleteOpen(false)
        setChecked(false)
        setStates({
            ...states,
            selectedRowKeys: []
        });
        setDrawerPage()
        setCountry()
        setState()
        setCity()
        if (FromPage !== "EntityUpdate" && ShortCut !== "Shortcut") {
            GetAll();
            setCratePage();
        }
        if (ShortCut === "Shortcut") {
            setCratePage()
        }
        if (drawerPage === "CloneLead" || ShortCut === "Shortcut") {
            PageCancel()
        }
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
        setUiReady(false)
    }
    const CloseDrawerNew = () => {
        setCancelConfirmOpen(false)
        setDrawerPage()
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    async function getData(id) {
        try {
            if (drawerPage === "CloneLead") {
                const responseData = await FetchContactDetails(id)
                const response = responseData.data
                getSharingPermissions(undefined)
                setData(response);
                setContactInitial(InitialData.ContactData)
                const transformedItem = {
                    ...response,
                    created_at: response.created_at ? convertAndFormatDateTime(response.created_time ? `${response.created_at} ${response.created_time}` : response.created_at, companyProfile, profile) : "",
                    modified_at: response.modified_at ? convertAndFormatDateTime(response.modified_time ? `${response.modified_at} ${response.modified_time}` : response.modified_at, companyProfile, profile) : "",
                };
                setDisplayData(transformedItem)
            } else {
                const responseData = await FetchContactDetails(id)
                if (!responseData.allow) throw new Error();
                const response = responseData.data
                getSharingPermissions(response?.sharingPermission?.sharePermission)
                setData(response);
                setInitialData(response)
                const transformedItem = {
                    ...response,
                    created_at: response.created_at ? convertAndFormatDateTime(response.created_time ? `${response.created_at} ${response.created_time}` : response.created_at, companyProfile, profile) : "",
                    modified_at: response.modified_at ? convertAndFormatDateTime(response.modified_time ? `${response.modified_at} ${response.modified_time}` : response.modified_at, companyProfile, profile) : "",
                };
                setDisplayData(transformedItem)
            }
        } catch (error) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    async function getData1(id, hideMessage, isAutomation, updateResponse) {
        try {
            const responseData = await FetchContactDetails(id)
            hideMessage();
            if (isAutomation) {
                successMessage("Automation rule triggered", updateResponse.data[0].message);
            } else {
                message.success(
                    <span>
                        Resident <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully
                    </span>
                );
            }
            if (!responseData.allow) throw new Error();
            const response = responseData.data
            getSharingPermissions(response?.sharingPermission?.sharePermission)
            setData(response);
            setInitialData(response)
            const transformedItem = {
                ...response,
                created_at: response.created_at ? convertAndFormatDateTime(response.created_time ? `${response.created_at} ${response.created_time}` : response.created_at, companyProfile, profile) : "",
                modified_at: response.modified_at ? convertAndFormatDateTime(response.modified_time ? `${response.modified_at} ${response.modified_time}` : response.modified_at, companyProfile, profile) : "",
            };
            setDisplayData(transformedItem)
            setTrigger("activity")
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew();
        } catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            if (isAutomation) {
                successMessage("Automation rule triggered", updateResponse.data[0].message);
            } else {
                message.success(
                    <span>
                        Resident <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully
                    </span>
                );
            }
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const { NavigationDecrypted } = useNavigationDecrypted()
    async function getEntityAvalibitlity() {
        let dataFound = true;
        try {
            const response = await NavigationDecrypted(UrlId[1])
            if (response) {
                setContactId(response)
                dataFound = true;
                getData(response)
            }
            else {
                dataFound = false;
            }
        } catch (error) {
            dataFound = false;
        }
        if (!dataFound) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const handleNoteClick = (value) => {
        setNotePopup(true)
        setPopupType(value)
        setNaCTrigger("trigger")
        setPage("Entity")
    }
    const handleCallLogClick = (value) => {
        setCallLogPopup(true)
        setPopupType(value)
        setNaCTrigger("trigger")
    }
    const AssignToFucntion = () => {
        if (approveCondition) { setApproveOpen(true); }
        else {
            setContactIDs([contactId])
            setUpdatePopup(true)
            setPopupType("Change Owner")
            setAction("SingleChangeOwner")
        }
    }
    const HandleShareClick = () => {
        setSharePopup(true)
    }
    const closeMailComposr = () => {
        setMailOpen(false);
    };
    const HandleAddCampaignClick = () => {
        setCampaignPopup(true)
    }
    const CreateTask = (id) => {
        setCreatePageTask("ListingLead")
        setNaCTrigger("trigger")
        setTaskProp({
            type: "Contact",
            ids: [id]
        })
    }
    const CreateMail = () => {
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            setNaCTrigger("trigger")
            setMailOpen(true)
        }
    }
    const CreateMeeting = (CId, firstname, lastname, mail) => {
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            setMeetingAttendees([{
                id: CId,
                name: `${firstname} ${lastname}`,
                type: "Contacts",
                email: mail,
            }])
            setNaCTrigger("trigger")
            setMeetingOpen(true)
        }
    }
    const getUserDetail = async () => {
        if (UrlId === undefined || UrlId === null) {
            if (profile.department === "Sales") {
                form.setFieldsValue({
                    leadOwner: profile.userId
                });
            }
        }
    }
    useEffect(() => {
        const currentUrlId = JSON.stringify(UrlId); // <-- serialize for comparison
        const currentFromPage = FromPage;
        const isCloneLead = drawerPage === "CloneLead";
        if (
            !isCloneLead &&
            prevValues.current.UrlId === currentUrlId &&
            prevValues.current.FromPage === currentFromPage
        ) {
            return;
        }
        prevValues.current = {
            UrlId: currentUrlId,
            FromPage: currentFromPage,
        };
        if (FromPage) {
            if (FromPage === "EntityUpdate") {
                if (drawerPage === "CloneLead") {
                    getData(contactId)
                    setDataPermissions("Read,Update,Delete,Sharing")
                    setEditField(true)
                    setEdit(true)
                }
                else {
                    getEntityAvalibitlity()
                }
            }
            else {
                form.setFieldsValue({
                    assistantcontactnumber: undefined,
                    accountName: undefined,
                    assistantname: undefined,
                    department: undefined,
                    description: undefined,
                    email: undefined,
                    fax: undefined,
                    contactSource: undefined,
                    firstName: undefined,
                    lastName: undefined,
                    leadOwner: undefined,
                    mobile: undefined,
                    phone: undefined,
                    postcode: undefined,
                    reportingto: undefined,
                    street: undefined,
                    title: "Mr.",
                    designation: undefined,
                    country: undefined,
                    seniorityLevel: undefined,
                    linkedinUrl: undefined,
                })
                setFileList([])
                setExpectedClosureDate(null)
                setImage()
                setDeleteOpen(false)
                setChecked(false)
                setContactId()
                setDrawerPage()
                setCountry()
                setState()
                setCity()
                getUserDetail()
                setDisplayData("Create")
                setContactInitial(InitialData.ContactData)
                setDataPermissions("Read,Update,Delete,Sharing")
                setEdit(true)
                setEditField(true)
            }
        }
    }, [UrlId, FromPage]);
    useEffect(() => {
        if (FromPage) {
            scroolup();
        }
    }, [FromPage])
    const fetchAll = async () => {
        await Promise.allSettled([
            AccountApi(),
            getCountry(),
            UserDetailsApi(),
            getContactsource(),
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (FromPage && editField && displayData) {
            fetchAll()
        }
    }, [FromPage, editField, displayData])
    const handleEditChange = () => {
        if (approveCondition) {
            setApproveOpen(true)
        }
        else {
            setEditField(true)
            setEdit(true)
            dispatch(setEditCall(true))
            setTrigger("")
            setApproveOpen(false)
        }
    }
    const createDeal = (Cid, Aid) => {
        setNaCTrigger("trigger")
        setCratePages("ContactPage")
        setDataForDeal({ AccountId: Aid, contactId: [Cid], contactDetails: displayData })
    }
    const CloneLead = () => {
        setDrawerPage("CloneLead")
    }
    const handleMergeclick = () => {
        if (approveCondition) {
            setApproveOpen(true)
            setMergeOpen(false)
        }
        else {
            setNaCTrigger("trigger")
            setApproveOpen(false)
            setMergeOpen(true)
        }
    }
    const moreAction = "Yes"
    const MoreAction = ({ closeDropdown }) => (
        <div style={{
            padding: "0px 10px",
            width: "100%",
            height: "100%",
        }}>
            <Link to={combinedUrl}
                onClick={(edit || !canCreate(permissions, 2006)) ? undefined : () => { CloneLead(); closeDropdown() }}
                className={`text_icon ${(edit || !canCreate(permissions, 2006)) ? "disabled_link" : ''}`}>
                <CloneIcon height={15} width={15} marginRight={5} /> Clone
            </Link>
            <Link to={combinedUrl} onClick={(edit || !canShare(dataPermissions, "Sharing")) ? undefined : () => { HandleShareClick(); closeDropdown() }} className={`text_icon ${(edit || !canShare(dataPermissions, "Sharing")) ? 'disabled_link' : ""}`}>
                <ShareIcon height={14} width={14} marginRight={5} /> Share
            </Link>
            <Link to={combinedUrl} onClick={(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2007)) ? () => { AssignToFucntion(); closeDropdown() } : undefined} className={`text_icon ${(canUpdateDelete(permissions, dataPermissions, "Update", 2007)) ? "" : 'disabled_link'}`}>
                <ChangeOwnerIcon height={15} width={15} marginRight={5} /> Change Owner
            </Link>
            <Link to={combinedUrl} onClick={(edit || !canCreate(permissions, 2006)) ? undefined : () => { handleNoteClick("Create"); closeDropdown() }} className={`text_icon ${(edit || !canCreate(permissions, 2006)) ? "disabled_link" : ''}`}>
                <NotesIcon height={15} width={15} marginRight={5} /> Add a Note
            </Link>
            <Link to={combinedUrl} onClick={(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2007)) ? () => { handleMergeclick(); closeDropdown() } : undefined} className={`text_icon ${(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2007)) ? "" : 'disabled_link'}`}>
                <MergeIcon height={15} width={15} marginRight={5} /> Merge Duplicates
            </Link>
            <Link to={combinedUrl}
                onClick={(edit || !canCreate(permissions, 2006)) ? undefined : () => { HandleAddCampaignClick(); closeDropdown() }}
                className={`text_icon ${(edit || !canCreate(permissions, 2006)) ? "disabled_link" : ''}`}>
                <CampaignIcon height={15} width={15} marginRight={5} />  Add to Campaign
            </Link>
        </div >
    );
    MoreAction.propTypes = {
        closeDropdown: PropTypes.func.isRequired,
    };
    const ButtonActions = [
        {
            Actions: <div className={(!canCreate(permissions, 2006)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Send Email'
                onClick={(!canCreate(permissions, 2006)) ? undefined : () => CreateMail()}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2006) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateMail()
                    }
                }}
                aria-label='mail'
            > <EmailIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2006)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Schedule a Meeting'
                onClick={(!canCreate(permissions, 2006)) ? undefined : () => CreateMeeting(contactId, displayData?.first_name, displayData?.last_name, displayData?.email)}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2006) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateMeeting(contactId, displayData?.first_name, displayData?.last_name, displayData?.email)
                    }
                }}
                aria-label='meeting'
            > <CalendarIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2006)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Create Task'
                onClick={(!canCreate(permissions, 2006)) ? undefined : () => CreateTask(contactId)}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2006) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateTask(contactId)
                    }
                }}
                aria-label='task'
            > <TaskIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2006)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Log a Call'
                onClick={(!canCreate(permissions, 2006)) ? undefined : () => handleCallLogClick("Create")}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2006) && (event.key === 'Enter' || event.key === ' ')) {
                        handleCallLogClick("Create")
                    }
                }}
                aria-label='phone'
            > <CallLogIcon height={20} width={20} /></div>
        },
    ]
    const LeadInfos = {
        profile: image,
        Classname: "ContactIcon",
        letterIcon: displayData?.first_name,
        name: `${displayData?.title ? displayData?.title : ""} ${displayData?.first_name} ${displayData?.last_name}`,
        subName: (displayData?.designation !== "" && displayData?.designation !== null && displayData?.designation !== "Not Applicable")
            ? (profile.dateFormate ? moment(displayData?.designation).format(profile.dateFormate) :
                (displayData?.designation && moment(displayData?.designation).format("YYYY-MM-DD"))) : "Date of Birth",
        mainAction: <><Button className="button_colors" size="small" style={{ width: "60%" }
        } onClick={() => createDeal(displayData?.contacts_id, displayData?.account_id)} disabled={!canCreate(permissions, 2014)}>
            <DealIcon height={25} width={25} /> Create Proposal
        </Button ></>,
    }
    const memoUrlId = useMemo(() => (UrlId ? [UrlId[0], contactId] : null), [UrlId, contactId]);
    const getDetailsDatas = useCallback(() => getData(contactId), [contactId]);
    const LeadDetails = (<ContactFields displayData={displayData} setNaCTrigger={setNaCTrigger} />);
    const RelatedDetails = (<RelatedTab EntityType="Contact" UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} emailactiontype={emailapiValues} disabledData={!canCreate(permissions, 2014)} displayData={displayData} trigger={trigger} />)
    const RightRelatedDetails = (<ContactRightData displayData={displayData} profile={profile} ViewDetailPage={ViewDetailPage} UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} trigger={trigger} />)
    const EditOpenForDrawer = () => {
        setEdit(true)
        dispatch(setEditCall(true))
    }
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true)
        let hideMessage;
        const {
            assistantcontactnumber,
            accountName, seniorityLevel,
            assistantname,
            department,
            description,
            email,
            fax,
            contactSource,
            firstName,
            lastName,
            leadOwner,
            mobile,
            phone,
            postcode,
            reportingto,
            street,
            title,
            linkedinUrl
        } = values;
        const payload =
        {
            seniorityLevelId: normalizeValue(seniorityLevel),
            firstName: normalizeValue(firstName),
            lastName: normalizeValue(lastName),
            leadOwner: normalizeValue(leadOwner),
            accountId: normalizeValue(accountName),
            title: normalizeValue(title),
            reportingTo: normalizeValue(reportingto),
            assitantName: normalizeValue(assistantname),
            department: normalizeValue(department),
            email: normalizeValue(email),
            phone: normalizeValue(phone),
            fax: normalizeValue(fax),
            designation: normalizeValue(expectedClosureDate),
            mobile: normalizeValue(mobile),
            contactSourceId: normalizeValue(contactSource),
            contactFiles: FILEList,
            contactProfile: normalizeValue(image),
            assitantContactNumber: normalizeValue(assistantcontactnumber),
            emailOtpOut: normalizeValue(checked),
            description: normalizeValue(description),
            city: normalizeValue(city),
            street: normalizeValue(street),
            country: normalizeValue(country),
            postcode: normalizeValue((postcode && postcode !== "") ? Number(postcode) : undefined),
            state: normalizeValue(state),
            linkedinUrl: normalizeValue(linkedinUrl)
        }
        const updatedFields = getChangedFields(payload, contactInitial);
        if (Object.keys(updatedFields).length === 0) {
            getData(contactId)
            scroolup()
            message.success("Resident updated")
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew()
            return;
        }
        try {
            hideMessage = message.loading("Loading...", 0);
            if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
                const response = await updateContacts(updatedFields, contactId)
                if (response.status === 200) {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                        loadingRef.current = false;
                        setDoubleClick(false)
                        hideMessage();
                    }
                    else {
                        const isAutomation = response.data[0].message === AutomationMessage;
                        const isApproval = response.data[0].message === ApprovalMessage;
                        const ownerChanged = displayData?.lead_owner !== leadOwner;
                        if (isApproval) {
                            hideMessage();
                            getData(contactId)
                            scroolup()
                            successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                            loadingRef.current = false;
                            setDoubleClick(false)
                            CloseDrawerNew()
                        }
                        else if (ownerChanged) {
                            hideMessage();
                            if (isAutomation) {
                                successMessage("Automation rule triggered", response.data[0].message);
                            } else {
                                message.success(
                                    <span>
                                        Resident <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                    </span>
                                );
                            }
                            dispatch(setEditCall(false));
                            history.push('/Home/residents');
                        }
                        else {
                            getData1(contactId, hideMessage, isAutomation, response)
                            scroolup()
                        }
                    }
                }
            }
            else {
                const response = await createContacts(updatedFields)
                if (response.status === 201) {
                    const isAutomation = response?.data === AutomationMessage;
                    const isApproval = response?.data === ApprovalMessage;
                    hideMessage();
                    if (isApproval) {
                        successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                    } else if (isAutomation) {
                        successMessage("Automation rule triggered", response?.data);
                    } else {
                        message.success(response?.data);
                    }
                    loadingRef.current = false;
                    setDoubleClick(false)
                    CloseDrawer();
                }
            }
        }
        catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            message.error(error)
        }
    }
    const showConfirmForAccount = (values) => {
        const modal = Modal.confirm({
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                    <span>Associated Account Change</span>
                </div>
            ),
            icon: null,
            className: "customice-confirm-modal",
            content: (
                <p>You are about to change the associated account for this record. This may affect linked data. Continue?</p>
            ),
            centered: true,
            okText: "No",
            cancelText: "Yes",
            okButtonProps: {
                className: "button_colorsModal"
            },
            cancelButtonProps: {
                className: "gray-buttonModal"
            },
            okCancel: true,
            onOk() {
                modal.destroy();
            },
            onCancel() {
                onSubmit(values)
            },
        });
    };
    const onSubmit1 = async (values) => {
        if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
            if (values.accountName !== displayData.account_id) {
                showConfirmForAccount(values)
            }
            else {
                onSubmit(values)
            }
        } else {
            onSubmit(values)
        }
    }
    const CloseDrawer2 = () => {
        scroolup();
        getData(contactId)
        setEditField(false)
        setEdit(false);
        dispatch(setEditCall(false))
        setDrawerPage()
    }
    const PageCancel1 = () => {
        if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
            CloseDrawer2()
        }
        else if (FromPage === "EntityUpdate" && drawerPage === "CloneLead") {
            setCancelConfirmOpen(true)
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    const getRefreshtheTable = () => {
        CloseDrawer2()
        setTrigger("activity")
    }
    const RequiredDateFormating = (dateString) => {
        const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
        const formattedDate = parsedDate.format("YYYY-MM-DD");
        return formattedDate;
    }
    const expectedClosureDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setExpectedClosureDate(formattedDate);
        form.setFieldsValue({ designation: date });
    };
    return (
        <>
            {FromPage === "EntityUpdate" ?
                <Main>
                    {displayData ? <>
                        {FromPage === "EntityUpdate" &&
                            <DetailsPage PageCancel={PageCancel} handleEditChange={handleEditChange} canUpdateDelete={canUpdateDelete}
                                UpdatePs={{ permission: permissions, dataPermission: dataPermissions, type: "Update", PId: 2007 }} moreAction={moreAction}
                                DetailsPageMoreAction={<MoreAction />} ButtonActions={ButtonActions} Maincontent={LeadInfos} UpdateDataPage={undefined}
                                EntityTabDetails={LeadDetails} EntityRelatedTab={RelatedDetails} RightRelatedDetails={RightRelatedDetails}
                            />}
                    </>
                        :
                        <div className="spin">
                            <Spin />
                        </div>}
                </Main> : <></>}
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={
                    FromPage === "EntityUpdate" ?
                        drawerPage === "CloneLead" ?
                            <span>
                                Clone Resident
                                {(displayData?.first_name || displayData?.last_name) && (
                                    <>
                                        <span style={{
                                            margin: '0 10px',
                                            color: '#d9d9d9',
                                            fontWeight: 'normal'
                                        }}>|</span>
                                        <span style={{ fontWeight: 'normal' }}>
                                            {`${displayData?.first_name || ''} ${displayData?.last_name || ''}`.trim()}
                                        </span>
                                    </>
                                )}
                            </span>
                            :
                            <span>
                                Update Resident
                                {(displayData?.first_name || displayData?.last_name) && (
                                    <>
                                        <span style={{
                                            margin: '0 10px',
                                            color: '#d9d9d9',
                                            fontWeight: 'normal'
                                        }}>|</span>
                                        <span style={{ fontWeight: 'normal' }}>
                                            {`${displayData?.first_name || ''} ${displayData?.last_name || ''}`.trim()}
                                        </span>
                                    </>
                                )}
                            </span>
                        : "Create Resident"
                }
                closable={false}
                placement="right"
                open={editField}
                width="80%"
                extra={
                    <Space>
                        {!edit ?
                            <div className='Hover-Refresh2 back-hover1 able-style'
                                role="button"
                                tabIndex={0} title='Edit'
                                onClick={() => EditOpenForDrawer()}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        EditOpenForDrawer()
                                    }
                                }}
                                aria-label='edit'
                            > <EditIcon height={20} width={20} /></div> : <></>}
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space>
                }
                footer={
                    (edit && uiReady) ? [
                        <div className="form_action_button">
                            <Button
                                className="gray-button" size="small"
                                onClick={() => PageCancel1()}
                            >
                                <CancelIcon height={25} width={25} />Cancel
                            </Button>
                            {FromPage === "EntityUpdate" && drawerPage !== "CloneLead" ?
                                <Button disabled={!canUpdateDelete(permissions, dataPermissions, "Delete", 2008) || deleteClick || doubleClick} loading={deleteClick}
                                    className="red-button" size="small"
                                    onClick={() => deleteMenu(contactId)}
                                >
                                    {!deleteClick && <DeleteIcon height={25} width={25} />}Delete
                                </Button> : <></>}
                            <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} disabled={deleteClick || doubleClick} loading={doubleClick}>
                                {!doubleClick && <SaveIcon height={25} width={25} />}{FromPage === "EntityUpdate" && drawerPage !== "CloneLead" ? "Update" : "Save"}
                            </Button>
                        </div>] : false
                }
            >
                {(displayData && uiReady) ? <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form">
                            {/* <AddProductForm> */}
                            <Form style={{ width: '100%' }} form={form} name="info" onFinish={(values) => onSubmit1(values)} onFinishFailed={onFinishFailed} colon={false}>
                                <BasicFormWrapper>
                                    <div className="add-product-block">
                                        <div style={{ margin: 40 }}>
                                            <Row gutter={15}>
                                                <Col xs={24}>
                                                    <div className="add-product-content">
                                                        <Heading as="h5">Basic Information</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="First Name" name="firstName" id="firstName"
                                                                    rules={[{ required: true, message: 'Please enter first name' }, {
                                                                        validator: (_, value) => {
                                                                            const error = nameOnChangeValidator(value, 25);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]}>
                                                                    <Input placeholder="Enter First Name" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Last Name" name="lastName" id="lastName"
                                                                    rules={[{ required: true, message: 'Please enter last name' }, {
                                                                        validator: (_, value) => {
                                                                            const error = nameOnChangeValidator(value, 25);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]}>
                                                                    <Input placeholder="Enter Last Name" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Date of Birth" name="designation"
                                                                    id="designation"
                                                                    rules={[{ required: true, message: 'Please select Date of Birth', }
                                                                    ]}>
                                                                    <DatePicker
                                                                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                        value={expectedClosureDate ? moment(expectedClosureDate, "YYYY-MM-DD") : null}
                                                                        onChange={expectedClosureDateChange}
                                                                        disabledDate={(current) => {
                                                                            return current && current > moment().endOf("day");
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Email Address" name="email"
                                                                    id="email" rules={[{ required: true, message: 'Please enter email address' }, {
                                                                        validator: (_, value) => {
                                                                            const error = validateEmailField(value, 50);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]} >
                                                                    <Input placeholder="Enter Email Address" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Name and Relationship (next of Kin)" name="mobile"
                                                                    id="mobile"
                                                                // rules={
                                                                //     [
                                                                //         {
                                                                //             validator: (_, value) => {
                                                                //                 const error = mobileOnChangeValidator(value, 20);
                                                                //                 if (error) {
                                                                //                     return Promise.reject(new Error(error));
                                                                //                 }
                                                                //                 return Promise.resolve();
                                                                //             },
                                                                //         },
                                                                //     ]
                                                                // }
                                                                >
                                                                    <Input placeholder="Enter Name and Relationship (next of Kin)" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Phone Number (Next of Kin)" name="phone"
                                                                    id="phone" rules={[
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = mobileOnChangeValidator(value, 20);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]}>
                                                                    <Input placeholder="Enter Phone Number" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="NHS Number" name="fax"
                                                                    id="fax" rules={
                                                                        [
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    const error = mobileOnChangeValidator(value, 20);
                                                                                    if (error) {
                                                                                        return Promise.reject(new Error(error));
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                },
                                                                            },
                                                                        ]
                                                                    }>
                                                                    <Input placeholder="Enter Fax Number" />
                                                                </Form.Item>
                                                            </Col>

                                                        </Row>
                                                        <Heading as="h5">Resident Information</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Resident Owner" name="leadOwner"
                                                                    id="leadOwner" rules={[{ required: true, message: 'Please select a resident owner', }]}>
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Resident Owner"
                                                                        showSearch
                                                                        optionLabelProp="label"
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }
                                                                    >
                                                                        {users}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Sponsor Name" name="accountName"
                                                                    id="accountName" rules={[{ required: true, message: 'Please select sponsor name', }]}>
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Sponsor Name"
                                                                        showSearch optionLabelProp="label"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }
                                                                        dropdownRender={(menu) => (
                                                                            <>
                                                                                {menu}
                                                                                <Divider style={{ margin: '8px 0' }} />
                                                                                <Space style={{
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center",
                                                                                    marginBottom: "-10px"
                                                                                }}>
                                                                                    <AntdButton type="text" onClick={() => setAddAccount(true)} icon={<PlusCircleOutlined />} disabled={!canCreate(permissions, 2010)} >
                                                                                        Add Sponsor
                                                                                    </AntdButton>
                                                                                </Space>
                                                                            </>
                                                                        )}
                                                                    >
                                                                        {account.filter((item) => item.account_type_name === "Customer").map((option, i) => (
                                                                            <Option value={option.account_id} key={i} label={(
                                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                    <div className='Div_flex2'>
                                                                                        <div className='share_image' title={`${option.account_name} (${option.account_number})`} style={{ cursor: "default" }}>
                                                                                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                                < img src={option.account_profile} alt="profile" />
                                                                                                :
                                                                                                <span className="image_icon AccountIcon">
                                                                                                    {option.account_name.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                            }
                                                                                            <span className='div-ellipsis'>{option.account_name}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>)}>
                                                                                <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                                                                                    <div>
                                                                                        {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                            < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                            :
                                                                                            <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                {option.account_name.slice(0, 1).toUpperCase()}
                                                                                            </span>
                                                                                        }</div>
                                                                                    <div>
                                                                                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                                                                        <p style={{ margin: 0 }}>{option.account_number}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </Option>))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Sponsor Url" name="department"
                                                                    id="department" rules={[
                                                                        // { required: true, message: 'Please enter department' },
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = validateUrlField(value, 2000);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]}>
                                                                    <Input placeholder="Enter Sponsor Url" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Referrer Name & Role" name="assistantname"
                                                                    id="assistantname"
                                                                // rules={[{
                                                                //     validator: (_, value) => {
                                                                //         const error = nameOnChangeValidator(value, 50);
                                                                //         if (error) {
                                                                //             return Promise.reject(new Error(error));
                                                                //         }
                                                                //         return Promise.resolve();
                                                                //     },
                                                                // }]}
                                                                >
                                                                    <Input placeholder="Enter Referrer Name & Role" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Referral Source" name="assistantcontactnumber"
                                                                    id="assistantcontactnumber">
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Referral Source"
                                                                        showSearch allowClear onChange={(value) => form.setFieldsValue({ assistantcontactnumber: value || null })}
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        <Option value="NHS / ICB">NHS / ICB</Option>
                                                                        <Option value="Local Authority">Local Authority</Option>
                                                                        <Option value="Community Mental Health Team">Community Mental Health Team</Option>
                                                                        <Option value="Hospital / Secure Unit">Hospital / Secure Unit</Option>
                                                                        <Option value="GP">GP</Option>
                                                                        <Option value="Social Worker">Social Worker</Option>
                                                                        <Option value="Self-Referral">Self-Referral</Option>
                                                                        <Option value="Other">Other</Option>
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Resident Source" name="contactSource"
                                                                    id="contactSource" rules={[{ required: true, message: 'Please select a contact source', }]}>
                                                                    <Select style={{ width: '100%' }} placeholder="Select Resident Source"
                                                                        showSearch
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }>
                                                                        {contactsource}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={24} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Primary Diagnosis / Reason for Referral" name="description" id="description" rules={
                                                                    [
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = validateDescriptionField(value, 2500);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]
                                                                }>
                                                                    <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Description' />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Heading as="h5">Address Information</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Country" name="country" id="country" rules={[{ message: 'Please select country', required: true }]}>
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch
                                                                        allowClear
                                                                        placeholder="Select Country"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={handleCountryChange}
                                                                        value={country}
                                                                    >
                                                                        {allCountry?.map((option) => (
                                                                            <Option key={option.countryId} value={option.country}>
                                                                                {option.country}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="State" >
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch
                                                                        allowClear
                                                                        placeholder="Select State"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={handleStateChange}
                                                                        value={state}
                                                                    >
                                                                        {allState?.map((option) => (
                                                                            <Option key={option.stateId} value={option.state}>
                                                                                {option.state}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="City" >
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch
                                                                        allowClear
                                                                        placeholder="Select City"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={handleCityChange}
                                                                        value={city}
                                                                    >
                                                                        {allCity?.map((option) => (
                                                                            <Option key={option.cityId} value={option.city}>
                                                                                {option.city}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Street name and No" name="street" id="street" rules={[{
                                                                    validator: (_, value) => {
                                                                        const error = validateAddressLine(value, 100);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                }]}>
                                                                    <Input placeholder="Enter Street name and no" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Zip Code" id="postcode" name="postcode" rules={[{
                                                                    validator: (_, value) => {
                                                                        const error = validateZipCode(value, 25);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                }]}>
                                                                    <Input placeholder="Enter Zip Code" />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row >
                                                        <RelatedDocUpload edit={edit} FILEList={FILEList} setFileList={setFileList} form={form} />
                                                        <Heading as="h5">Profile Picture</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <figure className="photoUpload align-center-v" >
                                                                    {image !== null && image !== undefined && image !== "" ?
                                                                        < img src={image} alt="" />
                                                                        :
                                                                        UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT" ?
                                                                            <span className='details_span_Tag ContactIcon'>
                                                                                {displayData?.first_name?.slice(0, 1).toUpperCase()}
                                                                            </span>
                                                                            :
                                                                            <span className='details_span_Tag ContactIcon'>
                                                                                C
                                                                            </span>}{edit && <figcaption>
                                                                                {deleteOption ? (
                                                                                    <div className='delete-div'>
                                                                                        <span className='delete-span'>
                                                                                            <FeatherIcon icon="trash-2" className="icon-svg" size={16} onClick={handleDeleteImage} />
                                                                                        </span>
                                                                                    </div>) :
                                                                                    (<div>
                                                                                        <ImgCrop aspect={1} cropShape="round" rotationSlider modalTitle="Crop Image">
                                                                                            <Upload {...FileUpload}>
                                                                                                <Link className="btn-upload" to={combinedUrl}>
                                                                                                    <FeatherIcon icon="camera" size={16} />
                                                                                                </Link>
                                                                                            </Upload></ImgCrop>
                                                                                    </div>)
                                                                                }
                                                                            </figcaption>}
                                                                </figure>
                                                            </Col>
                                                        </Row>
                                                        {(UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT" && drawerPage !== "CloneLead") && <>
                                                            <Heading as="h5">Other Information</Heading>
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Created Date" >
                                                                        <span >{displayData?.created_at}</span>
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Created By" >
                                                                        <UploadUserTag record={{
                                                                            uploadedBy: `${displayData?.createdByFirstName} ${displayData?.createdByLastName}`,
                                                                            uploadedById: displayData?.created_by,
                                                                            uploadedProfile: displayData?.createdByProfilePic
                                                                        }} />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Modified Date" >
                                                                        <span >{displayData?.modified_at}</span>
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Modified By" >
                                                                        <UploadUserTag record={{
                                                                            uploadedBy: `${displayData?.modifiedByFirstName} ${displayData?.modifiedByLastName}`,
                                                                            uploadedById: displayData?.modified_by,
                                                                            uploadedProfile: displayData?.modifiedByProfilePic
                                                                        }} />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row >
                                                        </>
                                                        }
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </BasicFormWrapper>
                            </Form>
                            {/* </AddProductForm> */}
                        </div>
                    </AddUser>
                </Scrollbars> :
                    <div className="spin">
                        <Spin />
                    </div>}</Drawer >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="contact" getCallBack={getRefreshtheTable} />}
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
            <AddTaskPage UrlId={undefined} FromPage={createPageTask} setCratePage={setCreatePageTask} CallBackTrigger={setNaCTrigger} fromPageforTask="FromDetails" taskProp={taskProp} />
            <AddDealPage UrlId={undefined} FromPage={createPages} setCratePage={setCratePages} dataForDeal={dataForDeal} CallBackTrigger={setNaCTrigger} />
            <ComposeMail mailOpen={mailOpen} close={closeMailComposr} entityName="Contacts" entity="EntityPages" toId={[{ id: displayData?.contacts_id, type: "Contacts" }]} CallBackTrigger={setNaCTrigger} />
            {approveOpen && <Approvaldialog confirmPopup={approveOpen} setConfirmPopup={setApproveOpen} />}
            {campaignPopup && <AddtoCampaignPopup sharePopup={campaignPopup} setSharePopup={setCampaignPopup} sharingType="Contact" sharingIds={[contactId]} PageTypes="Single" />}
            {sharePopup && <SharePopup sharePopup={sharePopup} setSharePopup={setSharePopup} sharingType="Contact" sharingIds={[contactId]} PageTypes="Single" />}
            {updatePopup && <Popup updatePopup={updatePopup} setUpdatePopup={setUpdatePopup} contactIDs={contactIDs} popupType={popupType} assignOwner={assignOwner} action={action} GetAll={getDetailsDatas} successMessage={successMessage} setDoubleClick={setDelteClick} loadingRef={loadingRef} deleteClick={deleteClick} />}
            {addAccount && <AddAccountPopup addAccount={addAccount} setAddAccount={setAddAccount} AccountApi={AccountApi} Callback={Callback} successMessage={successMessage} />}
            {notePopup && <NotesPopup setNotePopup={setNotePopup} notePopup={notePopup} popupType={popupType} UrlId={memoUrlId} page={page} setNaCTrigger={setNaCTrigger} />}
            {callLogPopup && <CallLogPopup setCallLogPopup={setCallLogPopup} callLogPopup={callLogPopup} popupType={popupType} UrlId={memoUrlId} setNaCTrigger={setNaCTrigger} />}
            {popupMessage && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType={pages} onNavigate={onnavigate} />}
            <MeetingLiPopup meetingOpen={meetingOpen} setMeetingOpen={setMeetingOpen} GetAll={getDetailsDatas} taskPage={taskPage} setNaCTrigger={setNaCTrigger} popupPageType="Create" meetingDate={formattedDate} meetingTime={formattedTime} Attendees={meetingAttendees} />
            <MergePage deletecheck={!hasRoleDeletePermission(permissions, 2008)} meetingOpen={mergeOpen} setMeetingOpen={setMergeOpen} GetAll={getDetailsDatas} pageIdentifier="Contacts" setNaCTrigger={setNaCTrigger} PryData={displayData} />
        </>
    );
}

AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    FromPage: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    ShortCut: PropTypes.string.isRequired,
};
export default AddNew;